<template>
  <div>
    <b-button
      variant="outline-primary"
      :disabled="loading"
      @click="aknowledge"
    >
      Aknowledge No Items Matched
      <b-spinner
        v-if="loading"
        label="Small Spinner"
        variant="primary"
        small
      />
    </b-button>
  </div>
</template>

<script>
import { BButton, BSpinner } from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BButton,
    BSpinner,
  },
  props: {
    receivedPoId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    aknowledge() {
      this.loading = true

      axios.post(`/invoices/aknowleged_unmatched_received_po/${this.receivedPoId}/`)
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Success',
              text: res?.data?.details || 'Recieved PO Aknowleged for no items match',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$emit('aknowleged')
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Error',
              text: error?.response?.data?.details || 'Failed to Aknowleged for no items match',
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        }).finally(() => {
          this.loading = false
        })
    },
  },
}

</script>
